export default {
  ADD_SERVICE: 'Dienst eintragen',
};
